<template>
  <the-detail :data="detail" />
</template>

<script>
import TheDetail from '@/components/TheDetail'

export default {
  components: { TheDetail },
  async asyncData({ redirect, app, params, $winstonLog }) {
    if (!/^\d+$/.test(params.id)) {
      return redirect('/news')
    }

    // 极致资讯详情
    try {
      const { data } = await app.$axios.post('/wbhome/news', { id: params.id })
      if (data.rcode === 0) {
        return {
          title: data.data.title || '',
          detail: data.data || {},
        }
      } else {
        return redirect('/news')
      }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return redirect('/news')
    }
  },
  head() {
    return {
      title: this.title,
    }
  },
}
</script>
